export const isValidEmailAddress = (email: string): boolean => {
  return (
    email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ) !== null
  );
};

export const isNotEmpty = (str: string): boolean => {
  return str.trim().length > 0;
};

export const isEmpty = (str: string): boolean => {
  return !isNotEmpty(str);
};

export const atLeast = (str: string, count: number): boolean => {
  return str.trim().length >= count;
};

export const isValidName = (name: string): boolean => {
  const regex = /^[A-Za-zÀ-ÿ\s'-]{2,}$/;

  return regex.test(name.trim());
};

export const isValidPhone = (phone: string): boolean => {
  const regex = /^\+?[0-9\s-]+$/;

  return regex.test(phone);
};
